import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiDialogsService } from './fi-dialogs.service';
import { FiDialogsCommonTwoButtonsComponent } from '@fi-shared/fi-dialogs/common-two-buttons/common-two-buttons.component';
import { FiSpinnerModule } from '@fi-shared/fi-spinner/fi-spinner.module';

@NgModule({
    imports: [
        CommonModule,
        MatDialogModule,
        MatButtonModule,
        MatCheckboxModule,
        MatIconModule,
        FiAppTextSharedModule,
        MatFormFieldModule,
        MatSelectModule,
        FormsModule,
        MatDividerModule,
        FiSpinnerModule,
    ],
    declarations: [FiDialogsCommonTwoButtonsComponent],
    providers: [FiDialogsService],
})
export class FiDialogsModule {}
